import React from "react";
import { Layout } from "react-admin";
import Menu from "./menu";

export default (props) => <Layout {...props} menu={Menu} />;
